import { ColumnConfig } from 'src/app/components/shared/table/components/table/types';

export const SMART_BAG_CONSTANTS = {
  HEADER: $localize`Auto-link Bags and Close ULD`,
  LEFT_BUTTON: $localize`Do not Link & Close`,
  RIGHT_BUTTON: $localize`Auto Link & Close`,
  PARENT_ULD: $localize`Parent ULD`,
};

export enum ColumnIds {
  BAG = 'bag',
  LOAD_NAME = 'loadName',
}

export const ColumnText = {
  BAG: $localize`Bag`,
  LOAD_NAME: $localize`Load Name`,
};

export const COLUMN_CONFIG: ColumnConfig[] = [
  {
    key: ColumnIds.BAG,
    title: ColumnText.BAG,
    isUpperCase: true,
  },
  {
    key: ColumnIds.LOAD_NAME,
    title: ColumnText.LOAD_NAME,
    isUpperCase: true,
  },
];

export type TableData = {
  bag: string;
  loadName: string;
};
